import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "paginator" }
const _hoisted_2 = ["onClick"]

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    pages: { type: Number, required: true },
},
  emits: ["navigate:prev", "navigate:next", "navigate:to"],
  setup(__props, { emit }: { emit: ({
    (e: "navigate:prev"): void;
    (e: "navigate:next"): void;
    (e: "navigate:to", page: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





function getPages(pagesCount: number): (number | null)[] {
    pagesCount = Math.ceil(pagesCount);
    const pages: (number | null)[] = [];

    for (let i = 1; i <= Math.min(pagesCount, 4); i++) {
        pages.push(i);
    }

    if (pagesCount > 4) {
        if (pagesCount > 5) {
            if (current.value > 5) pages.push(null);
            if (current.value > 4 && current.value < pagesCount) {
                pages.push(current.value);
            }
            if (current.value < pagesCount - 1) pages.push(null);
        }
        pages.push(pagesCount);
    }

    return pages;
}

function prev() {
    if (current.value <= 0) return;
    emit("navigate:prev");
    current.value--;
}

function next() {
    if (current.value >= Math.ceil(props.pages)) return;
    emit("navigate:next");
    current.value++;
}

function to(page: number) {
    page = Math.ceil(page);
    if (page < 0 || page > Math.ceil(props.pages)) return;
    emit("navigate:to", page);
    current.value = page;
}

const current = ref(1);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", { onClick: prev }, "◀"),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPages(__props.pages), (page) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (page !== null)
          ? (_openBlock(), _createElementBlock("span", {
              key: page,
              onClick: ($event: any) => (to(page)),
              class: _normalizeClass({ current: page === current.value })
            }, _toDisplayString(page), 11, _hoisted_2))
          : (_openBlock(), _createElementBlock("span", {
              key: page || -1
            }, "..."))
      ], 64))
    }), 256)),
    _createElementVNode("span", { onClick: next }, "▶")
  ]))
}
}

})